import { Component, ViewChild } from '@angular/core';
import { ScrBaseComponent } from '../../../base.component';
import { LinkedAccountsNavigatorComponent } from '../linked-accounts-navigator/linked-accounts-navigator.component';

@Component({
  selector: 'app-linked-accounts-all-codes',
  templateUrl: './linked-accounts-all-codes.component.html'
})
export class LinkedAccountsAllCodesComponent extends ScrBaseComponent {

  constructor() {
    super();
  }

  @ViewChild(LinkedAccountsNavigatorComponent) navigator!: LinkedAccountsNavigatorComponent;

  public interceptAction(accountId: number, fct: () => void): void {
    this.navigator.linkedAccountConfirm(accountId, fct);
  }
}
